import * as React from "react";
import Chart from "react-google-charts";
import { countrydetails } from "../models/countrydetails";
import { formatPieChartLabels } from "./../helpers"

interface Props {
  pfdPieChartData: countrydetails[];
  strPieChartData: countrydetails[];
}

const PieCharts = (props: Props) => {
  return (
    <div
      id="piecharts"
      style={{ height: "104px", padding: "0px 10px; width: 100%" }}
    >
      <div
        id="PFD"
        style={{
          border: "2px solid",
          float: "left",
          width: "49%",
          height: "100%"
        }}
      >
        <Chart
          chartType="PieChart"
          options={{ title: "PFDavg", pieSliceText: "none" }}
          data={[
            ["Section", "Contribution"],
            ...formatPieChartLabels(props.pfdPieChartData).map(row => [
              row.countryname,
              row.total
            ])
          ]}
          width={"100%"}
          height={"100%"}
        />
      </div>
      <div
        id="STR"
        style={{
          border: "2px solid",
          float: "right",
          width: "49%",
          height: "100%"
        }}
      >
        <Chart
          chartType="PieChart"
          options={{ title: "STR", pieSliceText: "none" }}
          data={[
            ["Section", "Contribution"],
            ...formatPieChartLabels(props.strPieChartData).map(row => [
              row.countryname,
              row.total
            ])
          ]}
          width={"100%"}
          height={"100%"}
        />
      </div>
    </div>
  );
};

export default PieCharts;
